// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Data / Images / Icons

function P_YouTube() {
  return (
    <DefaultLayout>P_YouTube</DefaultLayout>
  )
}

export default P_YouTube